export const auth0Cfg = {
    domain: "https://auth.bigmama.network",
    clientId: "KukuZ9sx2e1mJzEuJBHlLaFsDwMp6MJU",
    logoutUrl: "https://bigmama.network",
}
